/*
 * @Author: your name
 * @Date: 2020-11-06 13:24:26
 * @LastEditTime: 2020-12-23 15:46:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fe-yanjiusheng-h5/src/components/IconNav/index.js
 */
import React from 'react';
import Link from "../Link";
import { isH5Page } from '../../constrants/types';
import './index.scss';

const IconNav = ({ data, mod, className = "", ...props }) => {
  const ItemHtml = ({ item }) => {
    return (
      <Link
        className={`com-icon-item`}
        href={item.link_url}
        link_type={ isH5Page(item.link_page_type) ? 2 : 1 }
        link_page_type={item.link_page_type}
        link_page_id={item.link_page_id}
        link_page_param={item.link_page_param}
      >
        <img className="com-icon-item-img" src={item.img_url} />
        <p className="com-icon-item-text">{item.title}</p>
      </Link>
    )
  }
  console.log(data);
  return (
    <div
      className={`com-icon-nav ${className}`}
      {...props}
    >
      {
        data.map((el, index) => {
          return isH5Page(el.link_page_type) ? <ItemHtml item={el} key={index} /> : null
        })
      }
    </div>
  )
}


export default IconNav;